@if (!showForm || qrScannerVisible) {
  <h2>Aanmelden met</h2>
  @if (isErrorState && state !== stateEnum.ERROR) {
    <div
      class="border border-error error-container corner-s p-i-s p-b-xs"
      [innerHTML]="uiState.loginErrors[state]"
      @fadeIn
      @slideIn
      data-cy="login-error"
    ></div>
  }
  <div class="[ flex flex-wrap justify-center gap-m ]">
    <kabas-persisted-user-card [isAddNew]="true" (userCardClicked)="makeFormVisible()"></kabas-persisted-user-card>
    <ng-container *ngTemplateOutlet="loginOptions"></ng-container>
  </div>
  @if (persistedUsers?.length) {
    <div class="[ stack items-center ][ w-full p-b-xl ]">
      <dcr-divider></dcr-divider>
      <h3>of snel aanmelden</h3>
      <div class="[ flex flex-wrap justify-center gap-m ]">
        @for (persistedUser of persistedUsers; track persistedUser) {
          <kabas-persisted-user-card
            @popOut
            [isQuickLogin]="true"
            [person]="persistedUser"
            (quickLogin)="quickLogin($event)"
            (forgetAboutMe)="forgetPerson.emit($event)"
          ></kabas-persisted-user-card>
        }
      </div>
    </div>
  }
}

@if (showForm && !qrScannerVisible) {
  <h2>Aanmelden met een code</h2>
  <form
    [formGroup]="form"
    (ngSubmit)="submit()"
    data-cy="form-student-login"
    class="[ stack stack-space-s ][ relative items-center max-w-3xl ][ isolate ]"
  >
    <dcr-animated-kai
      #kai
      src="/assets/rive/kai_state_machine.riv"
      autoplay
      class="[ kai ][ index-pullback ]"
      track-lookat
      react-to-click
    ></dcr-animated-kai>
    @if (!quickLoginPerson) {
      <dcr-text-field
        formControlName="schoolCode"
        type="number"
        label="Schoolcode"
        data-cy="input-login-school-code"
        validation-message-required="Het lijkt erop dat je geen schoolcode invulde."
        [@wiggle]="isErrorState"
        class="w-full"
      ></dcr-text-field>
      <dcr-select
        formControlName="classGroupId"
        [supportingText]="uiState.classGroups[classGroupState]"
        label="Klas"
        valueAsNumber
        validation-message-required="Het lijkt erop dat je geen klas selecteerde."
        [@wiggle]="isErrorState"
        class="w-full"
        data-cy="select-login-class-group"
      >
        @for (classGroup of classGroups; track trackById($index, classGroup)) {
          <dcr-select-option [value]="classGroup.id" data-cy="option-login-class-group" [label]="classGroup.name"></dcr-select-option>
        }
      </dcr-select>
      <dcr-text-field
        label="Klasnummer"
        formControlName="classNumber"
        type="number"
        data-cy="input-login-class-number"
        [@wiggle]="isErrorState"
        class="w-full"
      ></dcr-text-field>
    } @else {
      <div class="[ stack surface-container-highest border corner-m p-i-s p-b-xs w-full ][ body-small ]">
        <div class="weight-bold">Hey {{ quickLoginPerson.firstName }}!</div>
        <div>
          Voer je nog even je wachtwoord in?
          <br />
          Zo zijn we zeker dat jij het bent.
        </div>
      </div>
    }
    <div class="flex gap-3xs items-center w-full">
      <dcr-text-field
        label="Wachtwoord"
        data-cy="input-login-child-code"
        formControlName="childCode"
        [type]="visibleCode ? 'text' : 'password'"
        validation-message-required="Het lijkt erop dat je geen wachtwoord invulde."
        [@wiggle]="isErrorState"
        class="flex-1"
      ></dcr-text-field>
      <dcr-inline-icon-button
        [icon]="visibleCode ? 'portal:visibility' : 'portal:visibility-off'"
        tiny
        aria-label="Toon wachtwoord"
        (click)="visibleCode = !visibleCode"
      ></dcr-inline-icon-button>
    </div>
    @if (isErrorState && state === stateEnum.ERROR) {
      <div
        class="border border-error error-container corner-s p-i-s p-b-xs"
        [innerHTML]="uiState.loginErrors[state]"
        @fadeIn
        @slideIn
        data-cy="login-error"
      ></div>
    }
    <div class="[ flex justify-center items-center gap-s ]">
      <dcr-tonal-button
        type="submit"
        label="Aanmelden"
        [disabled]="state !== stateEnum.PROCESSING && (form.invalid || state === stateEnum.SUCCESS || isErrorState)"
        class="title-medium"
        data-cy="btn-login-student-submit"
      ></dcr-tonal-button>
      @if (!!quickLoginPerson) {
        <dcr-inline-button (click)="notMeClicked()" [label]="'ik ben ' + quickLoginPerson.firstName + ' niet'"></dcr-inline-button>
      }
    </div>
  </form>
  @if (showQRLoginButton || showLearningIdLoginButton || showQuestiLoginButton) {
    <div class="[ stack items-center ][ w-full p-b-xl ]">
      <dcr-divider></dcr-divider>
      <h3>of snel aanmelden</h3>
      @if (isErrorState && state !== stateEnum.ERROR) {
        <div
          class="border border-error error-container corner-s p-i-s p-b-xs"
          [innerHTML]="uiState.loginErrors[state]"
          @fadeIn
          @slideIn
          data-cy="login-error"
        ></div>
      }
      <div class="[ cluster center-items ]">
        <div>
          <ng-container *ngTemplateOutlet="loginOptions"></ng-container>
        </div>
      </div>
    </div>
  }
}

<ng-template #loginOptions>
  @if (showQRLoginButton && !qrScannerVisible) {
    <kabas-persisted-user-card
      [isQRLogin]="true"
      (userCardClicked)="showQrScanner.emit(true)"
      data-cy="card-qr-login"
    ></kabas-persisted-user-card>
  }
  @if (showLearningIdLoginButton) {
    <kabas-persisted-user-card
      [isLeerIDLogin]="true"
      (userCardClicked)="ssoLogin('leerId')"
      [@wiggleLarge]="state === 'person_with_leerid_not_found'"
      data-cy="card-leer-id-login"
    ></kabas-persisted-user-card>
  }
  @if (showQuestiLoginButton) {
    <kabas-persisted-user-card
      [isQuestiLogin]="true"
      (userCardClicked)="ssoLogin('questi')"
      [@wiggleLarge]="state === 'unknown_questi_student'"
      data-cy="card-questi-login"
    ></kabas-persisted-user-card>
  }
</ng-template>
